
    <app-icon iconStyle="fal" iconName="info-circle" [pTooltip]="text" [tooltipPosition]="position" [escape]="escape" [tooltipStyleClass]="tooltipStyleClass"></app-icon>
  